import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { WHATSAPP_COLOR } from "../../../../constants/socialColors.constant";
import { IconProps } from "../Facebook/FacebookIcon";

export const WhatsappIcon = (props: IconProps) => {
  const { active, className, size = "1x", color } = props;
  return (
    <FontAwesomeIcon
      style={{
        color: color || (active ? WHATSAPP_COLOR : "gray"),
      }}
      icon={["fab", "whatsapp"]}
      className={className}
      size={size}
    />
  );
};
